module.exports = __webpack_public_path__ + "img/profile-home.3ea8a55b.svg";